export default __webpack_public_path__ + "static/media/ic_uganda.35070bd4.svg";